export const iplanBanner = [
  '420 50',
  `
    <svg xmlns="http://www.w3.org/2000/svg" width="420" height="50" viewBox="0 0 420 50">
      <title>i-plan manager banner</title>
      <style>
        .base-text {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          font-size: 36px;
          fill: black;
          text-anchor: middle;
          dominant-baseline: middle; 
        }
        .heavy-part {
          font-weight: 900;
        }
        .light-part {
          font-weight: 300;
        }
      </style>
      <text x="210" y="28" class="base-text">
        <tspan class="heavy-part">I-PLAN</tspan>
        <tspan dx="10" class="light-part">MANAGER</tspan>
      </text>
    </svg>
  `
];
